import React, { useEffect } from "react";
import { Box, Flex, Image, useMediaQuery } from "@chakra-ui/react";
import Header from "./Header";
import Hero from "../data/Home/Hero";
import Footer from "./Footer";
import { PATHS } from "../../routes/constants";
import { useLocation } from "react-router-dom";
import BusinessHero from "../data/BusinessRegistration/BusinessHero";
import RewardsHero from "../data/Rewards/RewardsHero";
import ApiServices from "../../pages/ApiServices/ApiServices";
import ApiUnifiedPlatform from "../../pages/ApiServices/ApiUnifiedPlatform";
import ApiUseCases from "../../pages/ApiServices/ApiUseCases";
import ApiProductSuite from "../../pages/ApiServices/ApiProductSuite";
import ApiSecurityCompliance from "../../pages/ApiServices/ApiSecurityCompliance";
import ApiQuickStart from "../../pages/ApiServices/ApiQuickStart";
import ApiDeveloperExperience from "../../pages/ApiServices/ApiDeveloperExperience";
import ApiSupport from "../../pages/ApiServices/ApiSupport";
import ApiGetStarted from "../../pages/ApiServices/ApiGetStarted";
import InvoiceHero from "../data/Invoice/InvoiceHero";
import PaymentLinkHero from "../data/PaymentLink/PaymentLinkHero";

const Layout = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === PATHS.HOME;
  const isRewardsPage = location.pathname === PATHS.REWARDS;
  const isApiServicesPage = location.pathname === PATHS.APISERVICES;
  const isInvoicePage = location.pathname === PATHS.INVOICE;
  const isPaymentLinkPage = location.pathname === PATHS.PAYMENT_LINK;
  const isBCommercePage = location.pathname === PATHS.B_COMMERCE;
  const isDsaPage = location.pathname === PATHS.DSA;
  const isDsaAgreementPage = location.pathname === PATHS.DSA_AGREEMENT;
  const isFullBleedMarketingPage = isBCommercePage || isDsaPage;
  const isDarkHeroPage = isInvoicePage || isPaymentLinkPage;
  const contentMaxW = isDarkHeroPage || isFullBleedMarketingPage ? 1440 : 1326;
  const [isMobile] = useMediaQuery(`(max-width: ${contentMaxW}px)`);
  const isActive =
    location.pathname === PATHS.HOME ||
    location.pathname === PATHS.REGPAGE ||
    location.pathname === PATHS.REWARDS ||
    location.pathname === PATHS.APISERVICES ||
    location.pathname === PATHS.INVOICE ||
    location.pathname === PATHS.PAYMENT_LINK;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.pathname]);

  return (
    <Flex flexDir="column" minH="100vh" w="full" bg="#fff" overflowX="hidden">
      <Header
        isActive={isActive}
        useDarkScrollBg={isActive || isBCommercePage}
        contentMaxW={`${contentMaxW}px`}
      />
      <Flex
        flexDir="column"
        justifyContent="center"
        align="center"
        w="full"
        px={{ base: "0", md: "0", lg: "unset" }}
      >
        <Flex
          justifyContent="center"
          align="center"
          flexDir="column"
          w="full"
          display={isActive ? "flex" : "none"}
        >
          <Flex
            bg={
              isDarkHeroPage
                ? "#0A1628"
                : isHomePage || isApiServicesPage || isRewardsPage
                  ? "dark"
                  : "#2463EB"
            }
            backgroundImage={isRewardsPage ? "url('/assets/rewardsHero.png')" : "none"}
            backgroundPosition="center"
            backgroundSize={isRewardsPage ? "cover" : "auto"}
            backgroundRepeat="no-repeat"
            minH={{
              base: "",
              md: isDarkHeroPage ? "auto" : "100vh",
            }}
            pb={{ base: "5rem", md: "unset" }}
            flexDir="column"
            pt={{ base: "90px", md: isDarkHeroPage ? "0" : "50px" }}
            justifyContent={{
              base: "flex-start",
              md: isDarkHeroPage ? "flex-start" : "center",
            }}
            align="center"
            w="100%"
            pos="relative"
          >
            {isRewardsPage ? (
              <Box
                pos="absolute"
                inset={0}
                bg="rgba(0, 0, 0, 0.36)"
                zIndex={1}
                pointerEvents="none"
                aria-hidden
              />
            ) : null}
            {isDarkHeroPage ? (
              <Box display={{ base: "none", md: "block" }} w="100%" pt="84px" pb="2px">
                <Box w="100%" h="1px" bg="#E2E8F029" />
              </Box>
            ) : null}
            <Image
              src="/assets/mob-pattern.svg"
              pos="absolute"
              w="full"
              top="0"
              h="100vh"
              objectFit="cover"
              display={
                isRewardsPage || isDarkHeroPage
                  ? "none"
                  : { base: "flex", md: "none" }
              }
            />
            <Image
              src="/assets/pattern.svg"
              pos="absolute"
              display={
                isRewardsPage || isDarkHeroPage
                  ? "none"
                  : { base: "none", md: "flex" }
              }
              w="full"
              top="0"
              h="100vh"
            />
            <Flex
              pos="relative"
              zIndex={2}
              w={isMobile ? "100%" : `${contentMaxW}px`}
              px={isRewardsPage ? { base: "8px", md: "49px" } : { base: "20px", md: "49px" }}
            >
              {isHomePage ? (
                <Hero />
              ) : isApiServicesPage ? (
                <ApiServices />
              ) : isRewardsPage ? (
                <RewardsHero />
              ) : isInvoicePage ? (
                <InvoiceHero />
              ) : isPaymentLinkPage ? (
                <PaymentLinkHero />
              ) : (
                <BusinessHero />
              )}
            </Flex>
          </Flex>
        </Flex>

        <Flex
          justifyContent="center"
          flexDir="column"
          align="center"
          w="full"
          display="flex"
        >
          <Flex
            pt={
              isFullBleedMarketingPage || isDsaAgreementPage
                ? '0'
                : isDarkHeroPage
                  ? { base: '16px', md: '16px' }
                  : isActive
                    ? { base: '40px', md: '24px' }
                    : '0'
            }
            pb="0"
            gap="18px"
            pos="relative"
            align="flex-start"
            px={isActive && !isFullBleedMarketingPage ? { base: "20px", md: "49px" } : "0"}
            justifyContent="center"
            w={
              isMobile || isFullBleedMarketingPage || isDsaAgreementPage
                ? "100%"
                : `${contentMaxW}px`
            }
          >
            <Box w="full">
              {isApiServicesPage ? (
                <>
                  <ApiUnifiedPlatform />
                  <ApiUseCases />
                  <ApiProductSuite />
                  <ApiSecurityCompliance />
                  <ApiQuickStart />
                  <ApiDeveloperExperience />
                  <ApiSupport />
                  <ApiGetStarted />
                </>
              ) : (
                children
              )}
            </Box>
          </Flex>
        </Flex>
      </Flex>
      <Box>
        <Footer variant={isDsaPage ? "dsa" : "default"} />
      </Box>
    </Flex>
  );
};

export default Layout;
